import {getDaysPassed} from "../model/caseHelpers";
import {timestampToDate} from "../../../utils/date";

type SortCasesProps = {
  cases: any[];
  sortColumn: string | null;
  sortOrder: "asc" | "desc";
};

export const sortCases = ({cases, sortColumn, sortOrder}: SortCasesProps) => {
  return [...cases].sort((a, b) => {
    if (!sortColumn) return 0;

    let valueA;
    let valueB;

    if (sortColumn === "createdAt") {
      valueA = a.createAt ? timestampToDate(a.createAt).getTime() : new Date(a.createAt).getTime();
      valueB = b.createAt ? timestampToDate(b.createAt).getTime() : new Date(b.createAt).getTime();
    } else if (sortColumn === "daysPassed") {
      valueA = getDaysPassed(a.createAt);
      valueB = getDaysPassed(b.createAt);
    } else if (sortColumn === "category") {
      valueA = a.category;
      valueB = b.category;
    } else if (sortColumn === "patientRegion") {
      valueA = a.patientRegion;
      valueB = b.patientRegion;
    }

    if (typeof valueA === "string" && typeof valueB === "string") {
      return sortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }

    return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
  });
};
